/*·······················
 map - Valink mod
 v3 : Google API, sans plugin, + fonctionnalités demandées par jojo
 v3.1 : infowindow facultative
 ·······················*/
/* Pattern HTML : EN MAJ
 pour passer des tableaux : htmlspecialchars(json_encode($adresses))
 #map[data-url] -> url du fichier PHP appelé en AJAX qui génère le JSON des markers
 #map[data-adresses] -> tableau d'adresse(s) au format (string)adresse ou (array)[lat, lng]
 #map[data-geolocate] -> booléen
 #map[data-overlay] -> booléen
 #map[data-zoom] -> booléen
 .cercle[data-rayon] -> en Km
 .cercle[data-lat], .cercle[data-lng] -> optionnels, si non rensigné, prend centre de la map de l'initialisation

 .route[data-origin], .route[data-destination] -> // cf fomat adresse
 */
function overrideExistingProperties(theTarget, theSource){
	for (var property in theSource)
		if (theSource.hasOwnProperty(property) && theTarget.hasOwnProperty(property))
			theTarget[property] = theSource[property];
}

function initMap() {
	map = $('#map');
	// var bounds = new google.maps.LatLngBounds();
	var markerBounds = [];
	var adressesCount = 0;

	// List the data params authorized and set default value
	var dataOptions = {
		lat      : 48.685108,
		lng      : 5.621274,
		relief   : true,
		zoom     : 10,
		restrictionsCountry : 'FR', // 2-digit code ccTLD? (exemple : 'FR','US', etc) https://www.wikiwand.com/en/Country_code_top-level_domain
		minZoom : 5,
		maxZoom : 20,
		adresses : false,
		styles : [
			{
				"featureType": "administrative.country",
				"elementType": "geometry",
				"stylers": [
					{
						"visibility": "simplified"
					},
					{
						"hue": "#ff0000"
					}
				]
			}
		]
	};

	// Default map options' value
	var mapOptions = {
		mapTypeControl    : false,
		zoomControlOptions: {
			position: google.maps.ControlPosition.TOP_LEFT
		},
		scaleControl      : true,
		rotateControl     : true,
		streetViewControl : false, // hide the yellow Street View pegman
		scrollwheel       : false, // allow users to zoom the Google Map
		disableDefaultUI  : false
	};

	// All is in name's function
	overrideExistingProperties(dataOptions,map.data());

	//-------------------- Processing datas to google params

	dataOptions.center        = {lat: dataOptions.lat, lng: dataOptions.lng};
	dataOptions.mapTypeId     = dataOptions.relief ? google.maps.MapTypeId.TERRAIN : google.maps.MapTypeId.NORMAL;
	dataOptions.middleZoom    = (dataOptions.maxZoom - dataOptions.minZoom) * .5 + dataOptions.minZoom;
	dataOptions.adresses      = (typeof dataOptions.adresses === 'string') ? [dataOptions.adresses] : dataOptions.adresses;
	dataOptions.adresses      = (dataOptions.adresses.constructor === Array) ? dataOptions.adresses : false;
	dataOptions.adressesTotal = Object.keys(dataOptions.adresses).length;

	//-------------------- Merging options

	$.extend(mapOptions, dataOptions);

	//-------------------- Initializing

	map = new google.maps.Map(document.getElementById(map.attr("id")), mapOptions);

	/*=========================================\
	 $data-adresses
	 \=========================================*/

	if (dataOptions.adresses) {
		$.each(dataOptions.adresses, function (cle, valeur) {
			location_to_marker(valeur);
		});
	}

	/*=========================================\
	 $HELPERS
	 \=========================================*/

	// Async fit map to markers
	function addressesBounds(total_addresses, address_count, myLatLng) {
		markerBounds.push(myLatLng);
		// make sure you only run this function when all addresses have been geocoded
		if (total_addresses <= address_count) {
			var latlngbounds = new google.maps.LatLngBounds();
			for ( var i = 0; i < markerBounds.length; i++ ) {
				latlngbounds.extend(markerBounds[i]);
			}
			map.setCenter(latlngbounds.getCenter());
			map.fitBounds(latlngbounds);

			if(total_addresses == 1){
				if (map.getZoom() > 18)
					map.setZoom(dataOptions.middleZoom);
			}
		}
	}

	function location_to_marker(data) {
		if (typeof data === 'string') { // adresse au format string
			// Geocode: https://developers.google.com/maps/documentation/javascript/geocoding?hl=fr
			var geocoder = new google.maps.Geocoder;
			geocoder.geocode({
				address              : data,
				region: 'fr',
				componentRestrictions: {
					country: dataOptions.restrictionsCountry ? dataOptions.restrictionsCountry : '',
				}
			}, function (results, status) { // console.log(results); pour plus d'infos, voir "Geocoding Results" sur //developers.google.com/maps/documentation/javascript/geocoding?hl=fr
				if (status == google.maps.GeocoderStatus.OK) {
					// Adresse partielle ou en dehors de la restriction
					if(results[0].partial_match == true && results[0].address_components.length <= 1){
						// SI geocoding partiel et retour qu'un adresse component, il y a de forte chance que ce soit une erreur et que le marker trouvé soit hors restriction
						console.info('%c status : geocoding annulé pour "' + data + '" par restriction de zone ou adresse érronée', 'background: blue; color: white; display: block;');
						dataOptions.adressesTotal = dataOptions.adressesTotal -1;
					}else{
						new google.maps.Marker({
							map     : map,
							position: results[0].geometry.location,
							icon    : 'images/marker.png'
						});
						adressesCount++;
					}
					addressesBounds(dataOptions.adressesTotal, adressesCount,results[0].geometry.location);
				}
				else {
					console.log('status : ' + status + ' - échec du geocoding de ' + data);
				}
			});
		}
		else if (typeof data === 'object') { // adresse au format coordonées ['lat'=>lat, ''lng'=>lng]
			new google.maps.Marker({
				map     : map,
				position: data,
				icon    : 'images/marker.png'
			});
			adressesCount++;
			addressesBounds(dataOptions.adressesTotal, adressesCount,data);
		}
		else
			console.log('format d\'adresse inconnu : ' + data);
	}

	/////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////
	////////////////////////////   NO CLEANED BELOW   ///////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////
	/*=========================================\
	 $drawOverlay
	 \=========================================
	 if (map_div.data('overlay')) {
	 map.drawOverlay({
	 lat    : lat,
	 lng    : lng,
	 content: '<div class="overlay"><h1>Overlay</h1></div>'
	 });
	 }

	 /*=========================================\
	 $cercle d'action
	 \=========================================

	 if (cercle = $('.cercle')) {
	 map.drawCircle({
	 lat          : (cercle_lat = cercle.data('lat')) ? cercle_lat : lat,
	 lng          : (cercle_lng = cercle.data('lng')) ? cercle_lng : lng,
	 radius       : parseInt(cercle.data('rayon')) * 1000,
	 strokeColor  : '#E6332A',
	 strokeWeight : 1,
	 strokeOpacity: 1,
	 fillColor    : '#E6332A',
	 fillOpacity  : 0.2
	 });
	 }

	 /*=========================================\
	 $géolocalisation
	 \=========================================

	 if (map_div.data('geolocate')) {
	 GMaps.geolocate({
	 success      : function (position) {
	 map.addMarker({
	 lat       : position.coords.latitude,
	 lng       : position.coords.longitude,
	 title     : 'Votre position',
	 draggable : true,
	 infoWindow: {
	 content: '<p>Votre position</p>'
	 }
	 });

	 map.fitZoom();
	 map.setZoom(map.getZoom() + 1);
	 if (map.getZoom() > 14) {
	 map.setZoom(14);
	 }

	 },
	 error        : function (error) {
	 console.log('Échec de la geolocation : ' + error.message);
	 },
	 not_supported: function () {
	 console.log("Geolocation non supporté par le navigateur");
	 }
	 });
	 }

	 /*=========================================\
	 $trajet
	 \=========================================

	 if ($('.route').length) {
	 var route = $('.route');
	 map.drawRoute({
	 origin       : route.data('origin'),
	 destination  : route.data('destination'),
	 travelMode   : 'driving',
	 strokeColor  : '#007776',
	 strokeOpacity: 0.65,
	 strokeWeight : 5,
	 });
	 }

	 /*=========================================\
	 $controles
	 \=========================================
	 map.addControl({
	 position: 'top_right',
	 content : '<i class="fa fa-fw fa-minus"></i>',
	 style   : {
	 fontFamily  : "FontAwesome",
	 fontSize    : '1.5em',
	 fontWeight  : '900',
	 margin      : '2em .2em',
	 marginRight : '2em',
	 padding     : '.3em .4em',
	 background  : '#fff',
	 borderRadius: '3px'
	 },
	 events  : {
	 click: function () {
	 map.zoomOut(1);
	 }
	 }
	 });
	 map.addControl({
	 position: 'top_right',
	 content : '<i class="fa fa-fw fa-plus"></i>',
	 style   : {
	 fontFamily  : "FontAwesome",
	 fontSize    : '1.5em',
	 fontWeight  : '900',
	 margin      : '2em .2em',
	 padding     : '.3em .4em',
	 background  : '#fff',
	 borderRadius: '3px'
	 },
	 events  : {
	 click: function () {
	 map.zoomIn(1);
	 }
	 }
	 });

	 */
}


